import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import IconButton from 'material-ui/IconButton';
import ExpandMore from 'material-ui/svg-icons/navigation/expand-more';
import ExpandLess from 'material-ui/svg-icons/hardware/keyboard-arrow-right';
import { orange500, cyan500 } from 'material-ui/styles/colors';
import IconDelete from 'material-ui/svg-icons/action/delete-forever';
import _ from 'lodash'

import UpRankButton from '../../../components/common/UpRankButton';
import DownRankButton from '../../../components/common/DownRankButton';

import colors from '../../../styles/colors'
import { Divider } from 'material-ui';
import '../../../resources/styles/CategoryLibrary.css';

const style = {
  groupHeader:{
    color: colors.accent,
    fontWeight:'bold',
    paddingLeft:'2%',
  },
  content:{
    width: '90%',
    margin:'auto',
    marginTop:'25px'
  },
  delete:{
    cursor:'pointer',
    color: colors.error
  },
};

class CategoryLibrary extends React.PureComponent {
  propTypes: {
    nodeText: PropTypes.string.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {
      text: props.nodeText,
    };

  }

  componentWillReceiveProps(props) {
    this.setState({
      text: props.nodeText
    });
  }

  render() {
    const {
      children,
    } = this.props;

    return (
      <div>
        <div className={'category-header'}>
          <h2 style={ style.groupHeader}>{this.state.text}</h2>
        </div>
        <Divider />
        <div className={'content'}>
          {children}
        </div>
      </div>
    );
  }
}

export default CategoryLibrary;



// WEBPACK FOOTER //
// ./src/layout/playbook/library/CategoryLibrary.js